module.exports = __webpack_public_path__ + "static/media/modal-background.1a362c8f.svg";